import { Component, OnInit, OnDestroy } from '@angular/core';
import { Router } from '@angular/router';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { CustomerStateService } from 'src/services/customer-state.service';
import { Observable, first, takeUntil, Subject, firstValueFrom, map, catchError, of } from 'rxjs';
import { ApiService } from 'src/services/api.service';
import { isValidPhoneNumber } from '../utils/string-helpers';
import { faEye, faEyeSlash } from '@fortawesome/free-solid-svg-icons';

@Component({
    selector: 'reset-password',
    templateUrl: './reset-password.component.html',
    styleUrls: ['./reset-password.component.scss']
})
export class ResetPwdComponent implements OnInit, OnDestroy {
    private readonly numbers = ['0', '1','2','3','4','5','6','7','8','9','Backspace', 'Delete', 'ArrowLeft', 'ArrowRight', 'ArrowDown', 'ArrowUp'];

    public consumerId: string = null;
    public phoneNumber: string;
    public validNumber: boolean = false;

    public tfaToken: string; // two factor authentication token
    public newPassword: string;
    public confirmPassword: string;

    public errMsg: string;
    public successMsg: string;

    showPassword: boolean = false;
    showConfirmPassword: boolean = false;
    faEye = faEye;
    faEyeSlash = faEyeSlash;
    
    constructor(
        private customerStateService: CustomerStateService,
        private router: Router, 
        private apiService: ApiService
    ){}

    ngOnInit(){
    }

    checkForNumber(event: KeyboardEvent){
        if((event.ctrlKey || event.metaKey) && event.key.toLowerCase() === 'v'){
            return;
        }

        if(this.numbers.includes(event.key)){
            this.errMsg = null;
        } else {
            event.preventDefault()
        }
    }

    pasteResetCode(event: ClipboardEvent){
        event.preventDefault();
        this.tfaToken = (event.clipboardData?.getData('text') ?? '')
            .replace(/\D/g, '')
            .substring(0, 6);
        this.errMsg = null;
    }

    toLogin(){
        this.router.navigate([`customer/${this.customerStateService.customerId}/login`])
    }

    clearConsumer(){
        this.consumerId = null;
        this.phoneNumber = null;
        this.validNumber = false;
        this.tfaToken = null;
        this.newPassword = null;
        this.confirmPassword = null;
        this.errMsg = null;
    }

    
    async getConsumer(){
        if(this.phoneNumber && isValidPhoneNumber(this.phoneNumber)){
            let consumerId = await firstValueFrom(this.apiService.getConsumerByNumber(this.customerStateService.customerId, this.phoneNumber).pipe(
                catchError(err => {
                    this.errMsg = "* No account found.";
                    return of(null);
                }), 
                map(consumer => consumer.id)
            ));
            if(consumerId){
                this.validNumber = true;
                this.consumerId = consumerId;
                this.errMsg = null;
                let x = await firstValueFrom(this.apiService.sendPasswordAuthToken(this.customerStateService.customerId, this.phoneNumber));
                console.log("Sent")
            }
        } else {
            this.errMsg = "* Please enter a valid phone number."
        }
    }

    async resetPassword(){
        this.errMsg = null;
        if(this.newPassword == this.confirmPassword){
            if(this.newPassword.length < 8){
                this.errMsg = "* Password must be at least 8 characters."
                return;
            }
            await firstValueFrom(this.apiService.resetPassword(this.phoneNumber, this.newPassword, this.confirmPassword, this.customerStateService.customerId, this.tfaToken).
                pipe(catchError(err => {
                    console.log(err)
                    if(err.error?.token?.[0]){
                        this.errMsg = `* ${err.error.token[0]}.`
                    } else if(err.error?.customerId?.[0]){
                        this.errMsg = `* ${err.error.customerId[0]}.`
                    } else if(err.error?.confirmPassword?.[0]){
                        this.errMsg = `* ${err.error.confirmPassword[0]}.`
                    } else if(err.error?.[""]){
                        this.errMsg = `* ${Array.isArray(err.error[""]) ? err.error[""][0] : err.error[""]}.`
                    } else {
                        this.errMsg = `* Password failed to update. Please verify your reset code and try again.`
                    }
                    return of(null);
                })));
                if(this.errMsg == null){
                    this.successMsg = "Password reset successfully. Please log in with your new password.";
                    console.log("Reset completed");
                    this.router.navigate([`customer/${this.customerStateService.customerId}/login`])

                }
        
            
        } else {
            this.errMsg = "* Passwords do not match."
        }
    }
    toggleShowPassword(){
        this.showPassword = !this.showPassword;
    }
    toggleShowConfirmPassword(){
        this.showConfirmPassword = !this.showConfirmPassword;
    }

    ngOnDestroy(){
    }
}